import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from '../../shared/components/Nav/Nav';

const NAV_ITEMS = [
	{
		id: 'inventory',
		label: 'Inventory',
		to: '/actuals/inventory',
	},
	{
		id: 'sales',
		label: 'Sales',
		to: '/actuals/sales',
	},
];

const ActualsNav = () => {
	const { pathname } = useLocation();

	const navItems = NAV_ITEMS;
	// global mode

	const match = useMemo(
		() => navItems.find((item) => pathname.startsWith(item.to)),
		[pathname]
	);

	return <Nav active={match?.id} items={navItems} />;
};

export default ActualsNav;
